import { Survey } from '../models/survey.model';

// Overall > recent > current/expected: overall and recent are only populated once the survey has run long enough to compute them.
export function surveyIr(survey: Survey): number {
  return (
    survey.overallIr ?? survey.recentIr ?? survey.currentIr ?? survey.expectedIr
  );
}

export function surveyLoi(survey: Survey): number {
  return survey.overallLoi ?? survey.recentLoi ?? survey.expectedLoi;
}
